var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screening-edit-task-content"},[_c('div',{staticClass:"screening-edit-task-content-1"},[_vm._v(_vm._s(_vm.taskContent1))]),_c('div',{staticClass:"screening-edit-task-content-2"},[_vm._v(_vm._s(_vm.taskContent2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }